'use strict';exports.__esModule = true;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};var _reactRouterRedux = require('react-router-redux');
var _isArray8 = require('lodash/isArray');var _isArray9 = _interopRequireDefault(_isArray8);
var _intersection = require('lodash/intersection');var _intersection2 = _interopRequireDefault(_intersection);
var _difference = require('lodash/difference');var _difference2 = _interopRequireDefault(_difference);
var _mapValues = require('lodash/mapValues');var _mapValues2 = _interopRequireDefault(_mapValues);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _constants = require('../constants');
var _stringifySelect = require('../utils/stringifySelect');var _stringifySelect2 = _interopRequireDefault(_stringifySelect);
var _findMappedLocalization = require('../utils/cities/findMappedLocalization');
var _slugify = require('./slugify');var _slugify2 = _interopRequireDefault(_slugify);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}

var SEPARATOR = '/';
var VALUE_SEPARATOR = '_';
var supportedLangs = _constants.language.supportedLanguages;
var prefixes = {
  centerPoint: 'c',
  toprightPoint: 't',
  zoom: 'z',
  price: 'price',
  types: 'types',
  status: 'status',
  rooms: 'rooms',
  commodities: 'commodities',
  floor: 'floor',
  propertyId: 'pid',
  favorites: 'fav',
  toilets: 'toilets',
  bathrooms: 'bathrooms',
  area: 'area',
  constructionYear: 'constructionYear',
  // Boolean values
  parkingSpot: 'parkingSpot',
  balcony: 'balcony',
  elevator: 'elevator',
  photos: 'photos',
  vr: 'vr',
  notLastFloor: 'notLastFloor',
  loadedWithPolygon: 'loadedWithPolygon' };

var booleanIdnentifiers = [
prefixes.parkingSpot,
prefixes.balcony,
prefixes.elevator,
prefixes.photos,
prefixes.vr,
prefixes.notLastFloor,
prefixes.favorites,
prefixes.loadedWithPolygon];

var specialIdentifiers = Object.values(prefixes);
var formatRouteString = function formatRouteString() {var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return (0, _slugify2.default)(str);};
var reformatName = function reformatName(name) {return name.split('-').map(function (str) {return str.charAt(0).toUpperCase() + str.slice(1);}).join(' ');};

var initialState = {
  parsed: false,
  fromHistory: false,
  data: {
    locale: null, // default
    location: '/',
    optionType: '',
    locationSearch: {
      en: {},
      he: {},
      isCity: false,
      isFull: false,
      isNeighborhood: false },

    params: {
      price: {},
      floor: {},
      rooms: null,
      types: null,
      photos: null,
      vr: null,
      balcony: null,
      elevator: null,
      parkingSpot: null,
      notLastFloor: null } } };




var appendBaseParams = function appendBaseParams(_ref) {var root = _ref.location,_ref$locale = _ref.locale,locale = _ref$locale === undefined ? '' : _ref$locale,optionType = _ref.optionType;
  var loc = locale && locale !== _constants.language.default ? locale + SEPARATOR : '';

  if (root !== SEPARATOR) {
    return !!optionType ? '' + loc + root + '/' + optionType : '' + loc + root;
  }

  return loc;
};

var appendAddressParams = function appendAddressParams() {var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { en: null, isCity: null },location = _ref2.en,isCity = _ref2.isCity,tags = _ref2.tags;
  var addressUrl = '';

  if (tags && tags.length) {
    addressUrl = SEPARATOR + tags.join(SEPARATOR);
  } else if (location && Object.keys(location).length > 0) {
    addressUrl += location.city_name ? SEPARATOR + formatRouteString(location.city_name) : '';

    if (!isCity) {
      addressUrl += location.neighborhood && location.neighborhood !== location.city_name ? SEPARATOR + formatRouteString(location.neighborhood) : '';
      addressUrl += location.street_name ? SEPARATOR + formatRouteString(location.street_name) : '';
      addressUrl += location.house_number ? SEPARATOR + formatRouteString(location.house_number) : '';
    }
  }
  return addressUrl;
};

var createMinMaxValue = function createMinMaxValue(min, max) {return max ? // eslint-disable-line no-nested-ternary
  min ?
  min + '-' + max : '0-' +
  max : '' +

  min;};


var appendFilterParams = function appendFilterParams() {var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var paramsUrl = '';

  for (var _iterator = Object.keys(params), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {var _ref3;if (_isArray) {if (_i >= _iterator.length) break;_ref3 = _iterator[_i++];} else {_i = _iterator.next();if (_i.done) break;_ref3 = _i.value;}var param = _ref3;
    var valueSeparator = VALUE_SEPARATOR;
    var value = params[param];

    /* eslint-disable no-continue */ // TODO: fix http://eslint.org/docs/rules/no-continue
    if (!value || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !Object.keys(value).length) {
      continue;
    }
    /* eslint-disable no-continue */

    var append = null;

    switch (param) {
      case 'types':
      case 'status':{
          append = (0, _isArray9.default)(value) ? value.length > 0 ? value.join(',') : null : value; // eslint-disable-line no-nested-ternary
          break;
        }
      case 'price':{
          var minPrice = value.minPrice ? value.minPrice : 0;
          var maxPrice = value.maxPrice ? value.maxPrice : null;
          append = !maxPrice ? !minPrice ? null : minPrice : minPrice + '-' + maxPrice; // eslint-disable-line no-nested-ternary
          break;
        }
      case 'rooms':{
          append = (0, _isArray9.default)(value) ? value.length > 0 ? (0, _stringifySelect2.default)(value).replace(/ /g, '') : null : value; // eslint-disable-line no-nested-ternary
          break;
        }
      case 'photos':
      case 'vr':
      case 'groundFloor':
      case 'elevator':
      case 'parkingSpot':
      case 'balcony':
      case 'notLastFloor':{
          // Booleans only with params
          valueSeparator = '';
          append = '';
          break;
        }
      case 'area':
      case 'floor':
      case 'constructionYear':{
          append = createMinMaxValue(value.min, value.max);
          break;
        }
      case 'bathrooms':
      case 'toilets':{
          append = (0, _isArray9.default)(value) ? value.length > 0 && value[0] !== 'all' ? (0, _stringifySelect2.default)(value) : null : value; // eslint-disable-line no-nested-ternary
          break;
        }
      case 'directions':{
          append = value;
          break;
        }
      case 'entryDate':{
          append = (0, _moment2.default)(value).format('DD.MM.YYYY');
          break;
        }
      case 'commodities':{
          append = value.join();
          break;
        }
      default:}


    if (append !== null) {
      paramsUrl += SEPARATOR + param + valueSeparator + append;
    }
  }

  return paramsUrl;
};

var appendLocationParams = function appendLocationParams() {var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { map: null, location: null, zoom: null },map = _ref4.map,location = _ref4.location,zoom = _ref4.zoom; // eslint-disable-line no-unused-vars
  var locationUrl = '';
  var decimalPoints = 6;

  var center = (0, _mapValues2.default)(location, function (num) {return num.toFixed(decimalPoints);});
  var topright = map && (0, _mapValues2.default)(map.topright, function (num) {return num.toFixed(decimalPoints);});

  if ((0, _get2.default)(center, 'lat') && !(0, _get2.default)(topright, 'lat')) {return locationUrl;}

  locationUrl += location ? '' + SEPARATOR + prefixes.centerPoint + '_' + center.lat + ',' + center.lon : '';
  locationUrl += topright && topright.lat && topright.lon ? '' + SEPARATOR + prefixes.toprightPoint + '_' + topright.lat + ',' + topright.lon : '';
  locationUrl += zoom ? '' + SEPARATOR + prefixes.zoom + '_' + zoom : '';

  return locationUrl;
};

var appendSearchResultParams = function appendSearchResultParams() {var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { page: null, propertyId: null },page = _ref5.page,propertyId = _ref5.propertyId;
  var resultUrl = '';

  resultUrl += page ? '' + SEPARATOR + prefixes.page + '_' + page : '';
  resultUrl += propertyId ? '' + SEPARATOR + prefixes.propertyId + '_' + propertyId : '';

  return resultUrl;
};

var appendExtraParams = function appendExtraParams(_ref6) {var favorites = _ref6.favorites;
  var result = '';
  if (favorites) {
    result += '' + SEPARATOR + prefixes.favorites;
  }
  return result;
};

var appendPolygonIfNeeded = function appendPolygonIfNeeded(obj) {
  var result = '';
  if (obj.loadedWithPolygon) {
    result += '' + SEPARATOR + prefixes.loadedWithPolygon;
  }
  return result;
};

// Main creator
var createUrl = function createUrl(obj) {
  var url = '';

  url += appendBaseParams(obj);
  url += appendAddressParams(obj.locationSearch);
  url += appendFilterParams(obj.params);
  url += appendLocationParams(obj.locationSearch);
  url += appendSearchResultParams(obj.searchResultParams);
  url += appendExtraParams(obj);
  url += appendPolygonIfNeeded(obj);

  return url[0] === SEPARATOR ? url : SEPARATOR + url;
};

var splitUrl = function splitUrl(url) {return url.
  split(SEPARATOR).
  slice(url[0] === SEPARATOR ? 1 : 0).
  filter(function (part) {return part !== 'undefined' && part !== 'null';});};

// Get locale, url location and option type
var parseBasePart = function parseBasePart(parts) {
  var localeSet = supportedLangs.indexOf(parts[0]) !== -1;
  var startIdx = localeSet ? 0 : 1;
  var result = {};
  result.locale = localeSet ? parts[startIdx] : _constants.language.default;
  result.location = parts[1 - startIdx];
  result.optionType = result.location === 'projects' ? null : parts[2 - startIdx];

  // Weird bug with pin.svg
  var endIdx = parts[parts.length - 1].toLowerCase() === 'pin.svg' ? parts.length - 1 : parts.length;
  // To avoid mutation
  var urlPartsIdx = !!result.optionType ? 3 : 2;
  result.urlParts = parts.slice(urlPartsIdx - startIdx, endIdx);
  return result;
};

var separateParts = function separateParts(parts) {
  var filterParts = [];
  var freeParts = [];

  for (var _iterator2 = parts, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {var _ref7;if (_isArray2) {if (_i2 >= _iterator2.length) break;_ref7 = _iterator2[_i2++];} else {_i2 = _iterator2.next();if (_i2.done) break;_ref7 = _i2.value;}var part = _ref7;
    var found = false;
    for (var _iterator3 = specialIdentifiers, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {var _ref8;if (_isArray3) {if (_i3 >= _iterator3.length) break;_ref8 = _iterator3[_i3++];} else {_i3 = _iterator3.next();if (_i3.done) break;_ref8 = _i3.value;}var prefix = _ref8;
      var index = part.trim().indexOf(prefix + '_');
      if (index === 0) {
        found = true;
        filterParts.push({ param: prefix, value: part.substr(prefix.length + 1) });
      }
    }
    if (!found) {
      freeParts.push(part);
    }
  }
  return { filterParts: filterParts, freeParts: freeParts };
};

var parseAddressPart = function parseAddressPart(parts) {
  var result = {};
  var freeParts = parts.filter(function (part) {return !!part && part !== 'search';});

  /* eslint-disable no-fallthrough */
  switch (freeParts.length) {
    case 3:
      result.house_number = reformatName(freeParts[2]);
    case 2:
      result.street_name = reformatName(freeParts[1]);
    case 1:
      result.city_name = reformatName(freeParts[0]);
      result.formatted = freeParts.length === 1 ?
      result.city_name : '' + (
      '' + (result.street_name ? result.street_name : '') + ('' + (
      result.house_number ? ' ' + result.house_number + ', ' : ', '))) +
      result.city_name;
      break;
    case 0:
      break;
    default:
      result.house_number = reformatName(freeParts[2]);
      result.street_name = reformatName(freeParts[1]);
      result.city_name = reformatName(freeParts[0]);}

  /* eslint-enable no-fallthrough */

  return result;
};

// Parsing rooms, toilets, bathrooms, needed separately too
var parseNumbersRange = function parseNumbersRange(numbersString, maxNumber) {
  var numbers = [];
  var numbersParts = numbersString.trim().split(',').map(function (str) {return str.trim();});

  for (var _iterator4 = numbersParts, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {var _ref9;if (_isArray4) {if (_i4 >= _iterator4.length) break;_ref9 = _iterator4[_i4++];} else {_i4 = _iterator4.next();if (_i4.done) break;_ref9 = _i4.value;}var numberPart = _ref9;
    var singleNumber = numberPart && !Number.isNaN(+numberPart);

    if (singleNumber) {
      var single = +numberPart > maxNumber ? maxNumber : +numberPart;
      numbers.push(single.toString());
    } else {
      // It is a "-" spread
      var numberSubParts = numberPart.split('-').map(function (subPart) {return subPart.trim();});

      var from = numberSubParts[0] && !Number.isNaN(+numberSubParts[0]) ? +numberSubParts[0] : null;
      var to = numberSubParts[1] && !Number.isNaN(+numberSubParts[1]) ? +numberSubParts[1] : null;

      to = to > maxNumber ? maxNumber : to;

      if (from !== null && to !== null) {
        for (var number = from; number <= to; number += 1) {
          numbers.push(number.toString());
        }
      }
    }
  }
  return numbers;
};

var getLocalisedAddress = function getLocalisedAddress() {var enAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var locale = arguments[1];
  var address = {};
  var cityKey = enAddress.city_name && (0, _slugify2.default)(enAddress.city_name);
  var neighborhoodKey = enAddress.neighborhood && (0, _slugify2.default)(enAddress.neighborhood);

  Object.keys(enAddress).forEach(function (key) {
    switch (key) {
      case 'city_name':
        address[key] = cityKey && (0, _findMappedLocalization.findMappedCityLocalization)(cityKey, locale);
        break;
      case 'neighborhood':
        address[key] = cityKey && neighborhoodKey &&
        (0, _findMappedLocalization.findMappedNeighborhoodLocalization)(cityKey, neighborhoodKey, locale);
        break;

      default:}

  });
  return address;
};

var parsePrice = function parsePrice(priceString) {
  var price = {};

  var prices = priceString.trim().split('-');
  price.minPrice = prices[0] && !Number.isNaN(+prices[0]) ? +prices[0] : null;
  price.maxPrice = prices[1] && !Number.isNaN(+prices[1]) ? +prices[1] : null;

  return price;
};

var parseMinMax = function parseMinMax(valueString) {
  var field = {};

  var values = valueString.trim().split('-');

  field.min = values[0] && !Number.isNaN(+values[0]) ? values[0] : null;
  field.max = values[1] && !Number.isNaN(+values[1]) ? values[1] : null;

  return field;
};

var parseBooleanPart = function parseBooleanPart(unprefixedParts) {
  var booleans = {};
  var same = (0, _intersection2.default)(unprefixedParts, booleanIdnentifiers);
  var freeParts = (0, _difference2.default)(unprefixedParts, booleanIdnentifiers);
  for (var _iterator5 = same, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {var _ref10;if (_isArray5) {if (_i5 >= _iterator5.length) break;_ref10 = _iterator5[_i5++];} else {_i5 = _iterator5.next();if (_i5.done) break;_ref10 = _i5.value;}var key = _ref10;
    booleans[key] = true;
  }

  return { booleans: booleans, freeParts: freeParts };
};

var parseFiltersPart = function parseFiltersPart(filterParts) {
  var params = { price: {} };
  var extraParts = [];

  for (var _iterator6 = filterParts, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {var _ref12;if (_isArray6) {if (_i6 >= _iterator6.length) break;_ref12 = _iterator6[_i6++];} else {_i6 = _iterator6.next();if (_i6.done) break;_ref12 = _i6.value;}var _ref11 = _ref12;var param = _ref11.param,value = _ref11.value;
    switch (param) {
      case prefixes.rooms:
        params.rooms = parseNumbersRange(value, 6);
        break;
      case prefixes.commodities:
      case prefixes.types:
      case prefixes.status:
        params[param] = value.split(',').map(function (val) {return val.trim();});
        break;
      case prefixes.price:
        params.price = parsePrice(value);
        break;
      case prefixes.floor:
        params.floor = parseMinMax(value);
        break;
      case prefixes.toilets:
        params.toilets = parseNumbersRange(value, 5);
        break;
      case prefixes.bathrooms:
        params.bathrooms = parseNumbersRange(value, 5);
        break;
      case prefixes.area:
        params.area = parseMinMax(value);
        break;
      case prefixes.constructionYear:
        params.constructionYear = parseMinMax(value);
        break;
      default:
        extraParts.push({ param: param, value: value });}

  }
  return { params: params, extraParts: extraParts };
};

var parseLocationPart = function parseLocationPart(filterParts) {
  var location = {};
  var extraParts = [];

  var center = (filterParts.find(function (part) {return part.param === prefixes.centerPoint;}) || {}).value;
  var topright = (filterParts.find(function (part) {return part.param === prefixes.toprightPoint;}) || {}).value;
  var zoom = (filterParts.find(function (part) {return part.param === prefixes.zoom;}) || {}).value;

  if (center) {
    var parsedCenterParts = center.split(',').map(function (part) {return +part.trim();}).filter(function (part) {return !Number.isNaN(part);});
    if (parsedCenterParts.length === 2) {
      location.center = { lat: parsedCenterParts[0], lon: parsedCenterParts[1] };
    }
  }

  if (zoom) {
    location.zoom = !Number.isNaN(+zoom) ? +zoom : null;
  }

  if (location.center && topright) {
    var parsedTopRightParts = topright.split(',').map(function (part) {return +part.trim();}).filter(function (part) {return !Number.isNaN(part);});
    if (parsedTopRightParts.length === 2) {
      location.map = {};

      location.map.topright = {
        lat: parsedTopRightParts[0],
        lon: parsedTopRightParts[1] };


      location.map.bottomleft = {
        lat: 2 * location.center.lat - location.map.topright.lat,
        lon: 2 * location.center.lon - location.map.topright.lon };

    }
  }

  return { location: location, extraParts: extraParts };
};

var parseSearchResultParams = function parseSearchResultParams(filterParts) {
  var searchResultParams = {};

  for (var _iterator7 = filterParts, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {var _ref14;if (_isArray7) {if (_i7 >= _iterator7.length) break;_ref14 = _iterator7[_i7++];} else {_i7 = _iterator7.next();if (_i7.done) break;_ref14 = _i7.value;}var _ref13 = _ref14;var param = _ref13.param,value = _ref13.value;
    switch (param) {
      case prefixes.pageNumber:
        searchResultParams.page = parseInt(value, 10);
        break;
      case prefixes.propertyId:
        searchResultParams.propertyId = value.trim();
        break;
      default:}

  }

  return searchResultParams;
};

// Main parser, memoized
var lastParseUrl = null;
var lastResult = null;
var parseUrl = function parseUrl(url) {
  if (lastParseUrl && lastResult && lastParseUrl === url) {
    return lastResult;
  }

  var paramsObj = Object.assign({},
  initialState.data, {
    locationSearch: Object.assign({}, initialState.data.locationSearch),
    params: Object.assign({}, initialState.data.params) });


  // Initial url parts
  var urlParts1 = splitUrl(url);
  // Parse
  var _parseBasePart = parseBasePart(urlParts1),urlParts2 = _parseBasePart.urlParts,base = _objectWithoutProperties(_parseBasePart, ['urlParts']);

  // Route parsing only on the results page
  // if (!base.optionType || base.location !== 'homes') {
  //   return paramsObj;
  // }

  // if (base.location === ROUTES_PATHS.FOREIGN) {
  //   return paramsObj;
  // }
  var _separateParts =
  separateParts(urlParts2),filterParts = _separateParts.filterParts,freeParts1 = _separateParts.freeParts;var _parseBooleanPart =
  parseBooleanPart(freeParts1),booleans = _parseBooleanPart.booleans,freeParts2 = _parseBooleanPart.freeParts;
  var address = parseAddressPart(freeParts2);var _parseFiltersPart =
  parseFiltersPart(filterParts),params = _parseFiltersPart.params,extraParts1 = _parseFiltersPart.extraParts;var _parseLocationPart =
  parseLocationPart(extraParts1),location = _parseLocationPart.location,extraParts2 = _parseLocationPart.extraParts;
  var searchResultParams = parseSearchResultParams(filterParts);

  paramsObj.tags = freeParts2;

  if (extraParts2.length > 0) {

  }

  // Assign
  paramsObj.locale = base.locale;
  paramsObj.location = base.location; // Route location, not physical, sorry for the confusion
  paramsObj.optionType = base.optionType;

  if (address) {
    paramsObj.locationSearch.isCity = Object.keys(address).length === 2 && !!address.city_name;
    paramsObj.locationSearch.isFull = !!(address.city_name && address.street_name && address.house_number);
    paramsObj.locationSearch.isNeighborhood = address.city_name && (address.neighborhood || address.street_name) &&
    address.city_name !== (address.neighborhood || address.street_name) && !address.house_number;
    paramsObj.locationSearch.en = address;
    paramsObj.locationSearch.he = getLocalisedAddress(address, 'he');
    paramsObj.locationSearch.ru = getLocalisedAddress(address, 'ru');
    paramsObj.locationSearch.fr = getLocalisedAddress(address, 'fr');
    paramsObj.locationSearch.unformattedCity = address.unformatted || undefined;
  }

  if (location.center) {
    paramsObj.locationSearch.location = location.center;
  }

  if (location.map) {
    paramsObj.locationSearch.map = location.map;
  }

  if (location.zoom) {
    paramsObj.locationSearch.zoom = location.zoom;
  }

  // Favorites param
  if (booleans[prefixes.favorites]) {
    paramsObj.favorites = booleans[prefixes.favorites];
    delete booleans[prefixes.favorites];
  }

  paramsObj.params = Object.assign({},
  params,
  booleans);


  if (searchResultParams) {
    paramsObj.searchResultParams = searchResultParams;
  }

  lastParseUrl = url;
  lastResult = paramsObj;

  return paramsObj;
};

var deleteLocation = function deleteLocation(route) {return route.
  split(SEPARATOR).
  filter(function (part) {return (
      part.indexOf(prefixes.centerPoint + VALUE_SEPARATOR) !== 0 &&
      part.indexOf(prefixes.toprightPoint + VALUE_SEPARATOR) !== 0 &&
      part.indexOf(prefixes.zoom + VALUE_SEPARATOR) !== 0);}).

  join(SEPARATOR);};

var prevRoute = null;
var extractRouteData = function extractRouteData(routing, locale) {
  var route = (0, _get2.default)(routing, 'locationBeforeTransitions.pathname', '').trim();
  var routingState = (0, _get2.default)(routing, 'locationBeforeTransitions.state', null);
  var routingKeys = routingState ? Object.keys(routingState) : [];
  var scrollPosition = routingKeys.length === 1 && routingKeys[0] === 'scrollPosition';
  var drawnPoly = !!(routingState && routingState.drawnPoly);

  var sameRouteAndState = routingState && !scrollPosition;
  var routeData = sameRouteAndState ? routingState : parseUrl(route);

  routeData.route = route;

  routeData.locale = !locale && !routeData.locale ?
  route.split('/').find(function (part) {return part.length === 2 && supportedLangs.indexOf(part) !== -1;}) || _constants.language.default // Force parsing
  : locale || routeData.locale;

  if (!sameRouteAndState) {
    if (prevRoute !== route && !drawnPoly) {
      (0, _reactRouterRedux.replace)(route, routeData);
    }
    // set(routing, 'locationBeforeTransitions.state', routeData);
  }
  prevRoute = route;

  // TODO: Investigate weird bug with locationSearch being a Location object
  // if (routeData.locationSearch.constructor.name === 'Location') {
  //   routeData.locationSearch = { ...initialState.data.locationSearch };
  // }

  return routeData;
};exports.default =

{
  parseBasePart: parseBasePart,
  splitUrl: splitUrl,
  separateParts: separateParts,
  parseAddressPart: parseAddressPart,
  parseFiltersPart: parseFiltersPart,
  parseLocationPart: parseLocationPart,
  appendBaseParams: appendBaseParams,
  appendAddressParams: appendAddressParams,
  appendFilterParams: appendFilterParams,
  appendLocationParams: appendLocationParams,
  parseUrl: parseUrl,
  createUrl: createUrl,
  parseNumbersRange: parseNumbersRange,
  deleteLocation: deleteLocation,
  extractRouteData: extractRouteData,
  initialState: initialState };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/routerAdapter.js
// module id = 72
// module chunks = 0